// export const all_privileges = [1, 2, 3, 4, 5, 6]
// export const agenda = [1, 2, 3, 4]
// export const jadwal = [1]
// export const akun = [1, 4]
// export const protokol = [1, 5]

export const ROLE_ADMIN = 1;
export const ROLE_OPERATOR = 2;
export const ROLE_PROTOCOL = 3;
export const ROLE_DEWAN = 4;
export const ROLE_PEGAWAI = 5;

export const all_privileges = [
  ROLE_ADMIN,
  ROLE_OPERATOR,
  ROLE_PROTOCOL,
  ROLE_DEWAN,
  ROLE_PEGAWAI,
];

export const admin_privilege = [ROLE_ADMIN];

export const operator_privileges = [ROLE_ADMIN, ROLE_OPERATOR];

export const protocol_privileges = [ROLE_ADMIN, ROLE_PROTOCOL];

export const dewan_privileges = [ROLE_ADMIN, ROLE_DEWAN];

// export const ACCESS_AGENDA = [ROLE_ADMIN, ROLE_USER, ROLE_MANAGER, ROLE_EDITOR];

// export const ACCESS_AKUN = [ROLE_ADMIN, ROLE_EDITOR];
